const module = 'admin'
const app = 'user'

export default {
  'api:admin:users:staffleave:list': `/${module}/${app}/staff-leaves`,
  'api:admin:users:staffleave:detail': `/${module}/${app}/staff-leaves/:id`,

  'api:admin:users:staffposition:list': `/${module}/${app}/staff-positions`,
  'api:admin:users:staffposition:detail': `/${module}/${app}/staff-positions/:id`,
}